import axios from '@/lib/axios';
import { PaymentTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1170. 支払タスク固定資産金額編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_fixed_assets/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
  amount: number;
};

const updatePaymentTaskFixedAsset = (props: Props): Promise<PaymentTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_fixed_assets/${props.id}`,
    props
  );
};

export const useUpdatePaymentTaskFixedAsset = () => {
  return useMutation({
    mutationFn: updatePaymentTaskFixedAsset,
  });
};
